import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  breadcrumbsBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '14px 24px 13px 24px',
    height: '60px',
    minHeight: '60px',
    background: palette.gradients.white,
    borderBottom: "1px solid ".concat(palette.shades[300]),
    boxShadow: palette.shadows.light,
    width: '100%',
    position: 'sticky',
    top: '0',
    left: '0',
    right: '0',
    zIndex: '101'
  }
});
export default useStyles;